import get from 'lodash.get';
import {
  addUser,
  fetchUser,
  updateIsFirstLogged,
  addUserDiet,
  updateUserOffice,
  deleteUserDiet,
  setUserAllergies,
  createUsers,
} from '@/services/user';

// eslint-disable-next-line no-unused-vars
const initializeUser = async (store, sessionExpired) => {
  const fetchUserResponse = await fetchUser(sessionExpired);
  let user = get(fetchUserResponse, 'data.getUser');
  if (!user) {
    const addUserResponse = await addUser();
    user = get(addUserResponse, 'data.addUser');
  }
  user.dietsInfo = user.dietsInfo ? user.dietsInfo.map((item) => item.name) : [];
  return user;
};

// eslint-disable-next-line no-unused-vars
const resetUser = (store) => ({
  id: undefined,
  name: undefined,
  email: undefined,
  role: undefined,
  office: undefined,
  isFirstLogged: undefined,
  officeInfo: {},
  dietsInfo: [],
});

const addUsersDiet = async ({ rootGetters, commit }, diet) => {
  const user = rootGetters['user/getUser'];
  commit('ADD_USER_DIET', diet);
  const addUserDietResponse = await addUserDiet({ user: user.id, diet: diet.id });
  if (!get(addUserDietResponse, 'data.addUserDiet')) {
    commit('REMOVE_USER_DIET', diet);
  }
};

const updateFirstLogIn = async ({ dispatch }, value) => {
  const updateIsFirstLoggedResponse = await updateIsFirstLogged(value);
  const firstLoggedin = get(updateIsFirstLoggedResponse, 'data.updateIsFirstLogged');
  if (firstLoggedin) {
    dispatch('initializeUser');
  }
  return firstLoggedin;
};

const updateUsersOffice = async ({ dispatch }, value) => {
  const updateUserOfficeResponse = await updateUserOffice(value);
  const officesUpdated = get(updateUserOfficeResponse, 'data.updateUsersOffice.updated');
  if (officesUpdated > 0) {
    dispatch('initializeUser');
  }
  return officesUpdated;
};

const deleteUsersDiet = async ({ rootGetters, commit }, diet) => {
  const user = rootGetters['user/getUser'];
  commit('REMOVE_USER_DIET', diet);
  const deleteUserDietResponse = await deleteUserDiet({ user: user.id, diet: diet.id });
  const dietDestroyed = get(deleteUserDietResponse, 'data.deleteUserDiet.destroyed');
  if (dietDestroyed === 0) {
    commit('ADD_USER_DIET', diet);
  }
  return dietDestroyed;
};

const setUsersAllergies = async ({ rootGetters, dispatch }, allergies = []) => {
  const user = rootGetters['user/getUser'];
  const setUserAllergiesResponse = await setUserAllergies({ user: user.id, allergies });
  const allergiesUpdated = get(setUserAllergiesResponse, 'data.setUserAllergies.updated');
  if (allergiesUpdated > 0) {
    dispatch('initializeUser');
  }
  return allergiesUpdated;
};

// eslint-disable-next-line no-unused-vars
const bulkCreateUsers = ({ commit }, users) => {
  createUsers(users);
};

export default {
  initializeUser,
  resetUser,
  addUsersDiet,
  updateFirstLogIn,
  updateUsersOffice,
  deleteUsersDiet,
  setUsersAllergies,
  bulkCreateUsers,
};



// WEBPACK FOOTER //
// ./store/modules/user/actions.js